import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
  selectors as authSel,
} from 'App/util/redux/auth/index';

// get redux store
const mapStateToProps = (state) => ({
  user: authSel.user(state),
});

@connect(
  mapStateToProps
)
class FullHeaderUserInfo extends Component {

  render() {
    return (
      <div id="user_info">
        {this.props.user.name}
      </div>
    );
  }
}

export default FullHeaderUserInfo;


// WEBPACK FOOTER //
// ./src/containers/Full/FullHeaderUserInfo.js